import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { usePhiDocumentReview } from "@/deploymentView";
import { intakeDocumentPath, intakeQueuePath } from "@/utils/productRoutes";

/**
 * One of the queue's addresses (#11422 round 19, R8): `intake` (the queue, or
 * a document's review page) on a deployment that reviews PHI documents,
 * `otherwise` (the documents product's page, or its 404) on every other. Only
 * the chosen element renders, so only its page's code is fetched.
 */
export const IntakeRoute: React.FC<{
  intake: React.ReactNode;
  otherwise: React.ReactNode;
}> = ({ intake, otherwise }) => (
  <>{usePhiDocumentReview() ? intake : otherwise}</>
);

/**
 * The queue's old address, `/claims` and `/claims/<id>`: replaced by the same
 * place at the queue's address, keeping the query string and the hash, so old
 * links, bookmarks and an open tab's history still reach their document.
 */
export const LegacyIntakeRedirect: React.FC = () => {
  const { itemId } = useParams<{ itemId?: string }>();
  const { search, hash } = useLocation();
  const target = itemId
    ? intakeDocumentPath(itemId, search)
    : intakeQueuePath(search);
  return <Navigate to={`${target}${hash}`} replace />;
};
